module.exports = __webpack_public_path__ + "img/bg-noise.fb96342b.png";